import { TitlelessCard, Icon, IconDefinitions } from "../../../../components";
import { LiveInspectionResponse } from "../../../../data/entities";

interface FilePickerCardProps {
  activeFiles: LiveInspectionResponse[];
  onFileSelect: (filePath: string) => void;
}

export function FilePickerCard({ activeFiles, onFileSelect }: FilePickerCardProps) {
  return (
    <TitlelessCard>
      <div
        className="d-flex flex-column align-items-center"
        style={{ padding: "0.5rem 0" }}
      >
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            backgroundColor: "rgba(56, 132, 244, 0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 10,
          }}
        >
          <Icon iconName={IconDefinitions.chartLine} className="text-primary" />
        </div>
        <h6 className="fw-semibold mb-1">Multiple active streams detected</h6>
        <p className="text-muted small mb-3">Select a file to start watching</p>
      </div>

      <div className="d-flex flex-column gap-2">
        {activeFiles.map((file) => (
          <div
            key={file.filePath}
            className="d-flex align-items-center justify-content-between"
            style={{
              backgroundColor: "var(--bs-light, #f8f9fa)",
              border: "1px solid #dee2e6",
              borderRadius: 8,
              padding: "12px 16px",
              cursor: "pointer",
              transition: "border-color 0.15s",
            }}
            onMouseOver={(e) => (e.currentTarget.style.borderColor = "#adb5bd")}
            onMouseOut={(e) => (e.currentTarget.style.borderColor = "#dee2e6")}
            onClick={() => onFileSelect(file.filePath)}
          >
            <div
              className="d-flex align-items-center gap-2"
              style={{ minWidth: 0, flex: 1 }}
            >
              <span
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: "#27ae60",
                  flexShrink: 0,
                }}
              />
              <div style={{ minWidth: 0, flex: 1 }}>
                <div className="fw-semibold" style={{ fontSize: "0.85rem" }}>
                  {file.fileName}
                </div>
                <code className="text-muted" style={{ fontSize: "0.72rem" }}>
                  {file.filePath}
                </code>
              </div>
            </div>
            <i
              className="fa fa-chevron-right text-muted ms-2"
              style={{ fontSize: "0.7rem" }}
            />
          </div>
        ))}
      </div>
    </TitlelessCard>
  );
}